import PaymentDialog from './PaymentDialog';
import ProfitDialog from './ProfitDialog';
import AuthSrcTypeDialog from './AuthSrcTypeDialog';
import RegionalManagerDialog from './RegionalManagerDialog';
import TechnicalSupportResponsibleDialog from './TechnicalSupportResponsibleDialog';
import AddrReportDialog from './AddrReportDialog';
import CustomerPriceListForm from './CustomerPriceListForm';
import CustomerOrderTypeForm from './CustomerOrderTypeForm';
import DealerAgreementTypeDialog from './DealerAgreementTypeDialog';
import { useUserAccountsData } from '../../../../user-definitions/user-accounts/hooks/useUserAccountsData';
import UserAccountsForm from '../../../../user-definitions/user-accounts/components/UserAccountsForm';

const DialogRenderer = ({ activeTab, visible, data, onHide, hooks, dealer, refreshDealerAddressUsers, dealerAddress, defaultCurrency = null, brand = null }) => {
    const handleSave = async (formData) => {
        const currentHook = hooks[activeTab];
        if (currentHook && currentHook.save) {
            await currentHook.save(formData);
        } else {
            console.warn(`No 'save' method found for active tab ${activeTab}.`);
        }
        onHide();
    };

    const handleRefreshAndClose = async () => {
        await refreshDealerAddressUsers?.();
        onHide();
    };

    const userAccountsHook = useUserAccountsData();

    if (activeTab === 0) {
        return <PaymentDialog visible={visible} data={data} onHide={onHide} onSave={handleSave} brand={brand} defaultCurrency={defaultCurrency} />;
    }

    if (activeTab === 1) {
        return <ProfitDialog visible={visible} data={data} onHide={onHide} onSave={handleSave} />;
    }
    if (activeTab === 2) {
        return <AuthSrcTypeDialog visible={visible} data={data} onHide={onHide} onSave={handleSave} />;
    }

    if (activeTab === 3) {
        return <RegionalManagerDialog visible={visible} data={data} onHide={onHide} onSave={handleSave} />;
    }

    if (activeTab === 4) {
        return <TechnicalSupportResponsibleDialog visible={visible} data={data} onHide={onHide} onSave={handleSave} responsibilityOrderOptions={hooks[activeTab]?.responsibilityOrderOptions} nextResponsibilityOrder={hooks[activeTab]?.nextResponsibilityOrder} />;
    }

    if (activeTab === 5) {
        return <AddrReportDialog visible={visible} data={data} onHide={onHide} onSave={handleSave} dealer={dealer} />;
    }
    // if (activeTab === 5) {
    //     return <CustomerPriceListForm visible={visible} data={data} onHide={onHide} onSave={handleSave} dealer={dealer} />;
    // }
    // if (activeTab === 6) {
    //     return null;
    // }
    if (activeTab === 6) {
        return <DealerAgreementTypeDialog visible={visible} data={data} onHide={onHide} onSave={handleSave} dealerAddressId={dealerAddress?.id} />;
    }
    if (activeTab === 7) {
        return (
            <UserAccountsForm
                visible={visible}
                onHide={onHide}
                onSubmit={async (formData) => {
                    try {
                        const result = await userAccountsHook.handleSave(formData);
                        if (result?.success) {
                            await handleRefreshAndClose();
                        }
                    } catch (error) {
                        console.error('Hata:', error);
                    }
                }}
                onRemove={async (selectedUser) => {
                    try {
                        const result = await userAccountsHook.handleRemove(selectedUser);
                        if (result?.success) {
                            await handleRefreshAndClose();
                        }
                    } catch (error) {
                        console.error('Silme hatası:', error);
                    }
                }}
                selectedUser={data}
                loading={userAccountsHook.loading}
                usageTypeOptions={userAccountsHook.usageTypeOptions}
                isEditMode={!!data}
                hasFormDataChanged={userAccountsHook.hasFormDataChanged}
                onFormDataChange={userAccountsHook.setFormOriginalData}
            />
        );
    }

    return null;
};

export default DialogRenderer;
